import { Button, createTheme, MantineColorsTuple } from "@mantine/core";

const customColor: MantineColorsTuple = [
  "#000000",
  "#000000",
  "#000000",
  "#000000",
  "#000000",
  "#000000",
  "#000000",
  "#000000",
  "#000000",
  "#000000",
];

export const theme = createTheme({
  colors: {
    customColor,
  },
  primaryColor: "customColor",
  components: {
    Button: Button.extend({
      vars: (theme, props) => {
        return { root: {} };
      },
    }),
  },
});
